import { IonChip } from '@ionic/react';
import styled from 'styled-components';
import { AllieChipProps } from './Chip.types';

export const StyledChip: any = styled(IonChip)<AllieChipProps>`
  background-color: ${(props: AllieChipProps) =>
    `var(--allie-color-${props.color?.backgroundColor})`};
  color: ${(props: AllieChipProps) => `var(--allie-color-${props.color?.allieColor})`};
  --padding-top: 10px;
  --padding-end: 15px;
  --padding-bottom: 10px;
  --padding-start: 15px;
  border-radius: ${(props: AllieChipProps) =>
    props.radius
      ? `var(--allie-radius-${props.radius})`
      : props.corner
        ? `var(--allie-corner-${props.corner})`
        : 'var(--allie-corner-rounded-edges)'};
  ${(props: AllieChipProps) =>
    props.allieType === 'error' ? `border: 2px solid var(--allie-color-error-main);` : ''}
  ${(props: AllieChipProps) =>
    props.color?.borderColor && `border: 1px solid var(--allie-color-${props.color.borderColor});`}
`;
